<template>
  <div class="point-selector-wrapper">
    <section @click="toggleOverview()" class="hero is-primary">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            Point Overview
          </h1>
          <h2 class="subtitle">
            View the history of tracked location
          </h2>
        </div>
      </div>
    </section>
    <div class="tracker-selector level is-mobile">
      <p class="level-left is-size-4">Set Tracker:</p>
      <select v-model="trackerId" @change="setPoint('latest')">
        <option
          v-for="tracker in user.trackers"
          :key="tracker"
          :value="tracker"
        >{{tracker}}</option>
      </select>
    </div>
    <div v-if="pointCell" class="point-selector level is-mobile">
      <p class="level-left is-size-4">Current point:</p>
      <span class="current-point-number level-right">
        <span class="icon is-large">
          <i
            @click="setPoint(pointCell.pointIndex - 1)"
            v-if="pointCell.pointIndex > 0"
            class="fas fa-2x fa-angle-left">
          </i>
        </span>
        <p class="is-size-4">{{pointCell.pointIndex + 1}}</p>
        <span class="icon is-large">
          <i
            @click="setPoint(pointCell.pointIndex + 1)"
            v-if="pointCell.pointIndex + 1 < pointCell.amountOfPoints"
            class="fas fa-2x fa-angle-right">
          </i>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pointSelector',
  props: {
    pointCell: [Object]
  },
  data: () => {
    return {
      trackerId: null
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  methods: {
    toggleOverview () {
      this.$emit('toggleOverview')
    },
    setPoint (index) {
      this.$emit('setPoint', { index, trackerId: this.trackerId })
    }
  },
  async created () {
    this.errorMessage = await this.$store.dispatch('getUser')
    if (this.user.trackers.length !== 0) this.trackerId = this.user.trackers[0]
    await this.setPoint('latest')
  }
}
</script>

<style scoped lang="scss">
  .point-selector, .tracker-selector {
    padding: 0.5rem 1.5rem;
    background:#f1f1f1;
  }
  .tracker-selector {
    margin-bottom: 0;
  }
</style>
